import { useEffect } from 'react'

interface SEOProps {
  title: string
  description?: string
  keywords?: string
}

const SEO = ({ title, description, keywords }: SEOProps) => {
  useEffect(() => {
    // 更新页面标题
    document.title = `${title} - 装个机`

    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description)
    }

    // 更新meta关键词
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords && keywords) {
      metaKeywords.setAttribute('content', keywords)
    }

    // 更新Open Graph标签
    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) {
      ogTitle.setAttribute('content', `${title} - 装个机`)
    }

    const ogDescription = document.querySelector('meta[property="og:description"]')
    if (ogDescription && description) {
      ogDescription.setAttribute('content', description)
    }

    // 更新Twitter标签
    const twitterTitle = document.querySelector('meta[property="twitter:title"]')
    if (twitterTitle) {
      twitterTitle.setAttribute('content', `${title} - 装个机`)
    }

    const twitterDescription = document.querySelector('meta[property="twitter:description"]')
    if (twitterDescription && description) {
      twitterDescription.setAttribute('content', description)
    }
  }, [title, description, keywords])

  return null
}

export default SEO
